import { useContext } from 'react';
import type { InvitePeopleProps, CloseTrigger } from '../../types';
import { InvitePeopleModalContext } from './InvitePeopleModalContext';

type useInvitePeopleModalProps = {
	onClose?: (trigger?: CloseTrigger) => void;
};

/**
Allows opening and closing of the Invite People Modal from within the InvitePeopleModalContext
*/
export const useInvitePeopleModal = (
	useInvitePeopleModalProps: useInvitePeopleModalProps & InvitePeopleProps,
) => {
	const { onClose, ...invitePeopleProps } = useInvitePeopleModalProps;
	const { openModal, closeModal, isOpen } = useContext(InvitePeopleModalContext);

	return {
		// this is experimental only and should not be used without consulting !core-invtes in #groot-techops
		experimental_openModal: (propsOverride: Partial<InvitePeopleProps>) =>
			openModal(
				{
					...invitePeopleProps,
					...propsOverride,
				},
				onClose,
			),
		openModal: () => openModal(invitePeopleProps, onClose),
		closeModal,
		isOpen,
	};
};
